import axios from 'axios';
import React, { useState, useEffect } from 'react'
import Main from '../Main'
import BackToService from './BackToService';
import notFound from '../assets/img/undraw_not_found_60pq.png'
import movieDetailsConfig from '../Config/movieDetailsConfig';

function MovieDetails() {
    const [query, setQuery] = useState("unknown");
    const [year, setYear] = useState();
    const [movieDetails, setMovieDetails] = useState(null);
    const [isResultGet, setIsResultGet] = useState(false);

    const fetchDetails = async () => {
        try {
            const { data } = await axios.get(`${movieDetailsConfig}&t=${query}&y=${year}`);

            if (data.Error) {
                setIsResultGet(false);
            } else {
                setMovieDetails(data);
                setIsResultGet(true);
            }
        } catch (error) {
            setIsResultGet(false)
        }
    };

    useEffect(() => {
        fetchDetails();
    }, [])

    if (!isResultGet) {
        return (
            <>
                <Main active="service">
                    <div className="main">
                        <section>
                            <div className="container section-title">
                                <h2>Movie's Details <BackToService /></h2>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="input-group mb-3">
                                            <input type="text" className="form-control" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Movie Title" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                            <input type="number" className="form-control" value={year} onChange={(e) => setYear(e.target.value)} placeholder="Year" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                            <div className="input-group-append">
                                                <button className="btn btn-primary" disabled={query ? false : true} type="button" onClick={fetchDetails}>Search</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="card">
                                            <img src={notFound} alt="" style={{ "height": "calc(100vh - 330px)" }} className="img-thumbnail" />
                                            <h4 style={{ "color": "#173b6c", "textAlign": "center" }}>Movie not found!</h4>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </Main>
            </>
        )
    } else {
        return (
            <>
                <Main active="service">
                    <div className="main">
                        <section>
                            <div className="container section-title">
                                <h2>Movie's Details <BackToService /></h2>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="input-group mb-3">
                                            <input type="text" className="form-control" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Movie Title" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                            <input type="number" className="form-control" value={year} onChange={(e) => setYear(e.target.value)} placeholder="Year" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                            <div className="input-group-append">
                                                <button className="btn btn-primary" disabled={query ? false : true} type="button" onClick={fetchDetails}>Search</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="card">
                                            <img src={movieDetails ? movieDetails.Poster : ""} alt="" style={{ "max-height": "calc(100vh - 330px)" }} className="img-thumbnail" />
                                            <h4 style={{ "color": "#173b6c", "textAlign": "center" }}>{movieDetails ? movieDetails.Title : ""}</h4>
                                        </div>
                                    </div>
                                    <div className="col-md-8 row" style={{ "maxHeight": "calc(100vh - 330px)", "overflowY": "auto" }}>
                                        <div className="col-md-3"><strong sty>Released</strong></div><div className="col-md-9">{movieDetails ? movieDetails.Released : ""}</div>
                                        <div className="col-md-3"><strong>Type  </strong></div><div className="col-md-9">{movieDetails ? movieDetails.Type : ""}</div>
                                        <div className="col-md-3"><strong>Genre  </strong></div><div className="col-md-9">{movieDetails ? movieDetails.Genre : ""}</div>
                                        <div className="col-md-3"><strong>Language  </strong></div><div className="col-md-9">{movieDetails ? movieDetails.Language : ""}</div>
                                        <div className="col-md-3"><strong>Country </strong></div><div className="col-md-9">{movieDetails ? movieDetails.Country : ""}</div>
                                        <div className="col-md-3"><strong>Writer  </strong></div><div className="col-md-9">{movieDetails ? movieDetails.Writer : ""}</div>
                                        <div className="col-md-3"><strong>Director  </strong></div><div className="col-md-9">{movieDetails ? movieDetails.Director : ""}</div>
                                        <div className="col-md-3"><strong>Actor  </strong></div><div className="col-md-9">{movieDetails ? movieDetails.Actors : ""}</div>
                                        <div className="col-md-3"><strong>imdbRating  </strong></div><div className="col-md-9">{movieDetails ? movieDetails.imdbRating : ""}</div>
                                        <div className="col-md-3"><strong>Awards  </strong></div><div className="col-md-9">{movieDetails ? movieDetails.Awards : ""}</div>
                                        <div className="col-md-3"><strong>Description  </strong></div><div className="col-md-9">{movieDetails ? movieDetails.Plot : ""}</div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </Main>
            </>

        )
    }
}

export default MovieDetails
